import ZPattern from './pattern.vue'

ZPattern.install = function(app) {
  app.component(ZPattern.name, ZPattern)
}

export default ZPattern